import './global.scss' // app & third-party component styles

import { configureStore, Middleware } from '@reduxjs/toolkit'
import createSagaMiddleware, { SagaMiddleware } from 'redux-saga'

import appolloClient from 'myNet'
import conf from 'conf'
import history from 'history'

import reducers from 'redux/reducers'
import sagas from 'redux/sagas'
import NativeInterface from 'services/native-interface/om-native-client'

import rootRender from 'rootRender'
import { _initStore } from 'env'

import * as serviceWorker from './serviceWorker'

import { initSentry } from 'services/sentry'
import { reloadForStaleChunk } from 'utils/chunkReload'

// dev/staging 전용 window 테스트 후크 등록 (프로덕션에서는 dead code)
import './devHooks'

initSentry()

// Vite dynamic-import 실패 시 자동 reload (신규 배포로 구버전 HTML의 chunk가 사라진 경우 복구)
// - update-check.js는 HTML로 제공되는 SyntaxError만 처리하므로 ChunkLoadError 대응은 별도로 필요
// - 정상 복구(첫 실패→reload) 경로에서만 preventDefault() 호출해 Vite의 원본 throw를 억제
// - 30초 내 재실패 케이스(reloadForStaleChunk가 false 반환)는 Vite 기본 동작에 맡겨 Sentry로 보고
//   (@loadable lazy loader의 같은 복구 로직은 utils/chunkReload의 loadWithChunkRetry가 공유)
window.addEventListener('vite:preloadError', (event) => {
  if (reloadForStaleChunk()) {
    event.preventDefault()
  }
})

if (NativeInterface.isAvailable()) {
  // Native → Web 콜백 등록
  NativeInterface.register()
}

// middlewared
const sagaMiddleware: SagaMiddleware = createSagaMiddleware()
const middlewares: Middleware[] = [sagaMiddleware]

console.info(`Git branch : ${conf.gitInfo.branch}`)
console.info(`Git date : ${conf.gitInfo.commit.date}, ${conf.gitInfo.commit.hash.substring(0, 7)}`)
console.info(import.meta.env.VITE_APP_NAME, import.meta.env.VITE_APP_VERSION)

const store = configureStore({
  reducer: reducers(),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: false,
      immutableCheck: false,
      serializableCheck: false,
    }).concat(middlewares),
  devTools: !__ENV_PRODUCTION__,
})

sagaMiddleware.run(sagas)

_initStore(store) // env.ts에 store 주입 (lazy 초기화)

rootRender(appolloClient, store, history)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
export { store, history }

// Export RootState and AppDispatch types for use throughout the app
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
